import { http, HttpResponse } from 'msw';
import { ddWeather } from '../gallery/dummydata/ddWeather';

export const handlersSmhi = [
  /**
   * @see https://opendata.smhi.se/apidocs/metfcst/index.html
   */
  http.get(
    `https://opendata-download-metfcst.smhi.se/api/category/pmp3g/version/2/geotype/point/lon/:lon/lat/:lat/data.json`,
    () => HttpResponse.json(ddWeather),
  ),
];
